<template>
  <scoped v-if="value">
    <div>
      <Enumeration
        v-if="contactDetailsTypes"
        v-model:selection="value.type"
        title="Type"
        :options="contactDetailsTypes"
        :readOnly="readOnly"
      />
    </div>
    <div class="column">
      <h2>
        Name
      </h2>
      <TextInput
        v-model:value="value.forename"
        title="Forename"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.surnamePrefix"
        title="Surname Prefix"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.surname"
        title="Surname"
        :readOnly="readOnly"
      />
    </div>
    <div class="column">
      <h2>
        Location
      </h2>
      <TextInput
        v-model:value="value.address"
        title="Address"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.postalCode"
        title="Postal Code"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.city"
        title="City"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.country"
        title="Country"
        :readOnly="readOnly"
      />
    </div>
    <div class="column">
      <h2>
        Method
      </h2>
      <TextInput
        v-model:value="value.email"
        title="Email"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.phone"
        title="Phone"
        :readOnly="readOnly"
      />
      <TextInput
        v-model:value="value.website"
        title="Website"
        :readOnly="readOnly"
      />
    </div>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import Enumeration from "@/components/selectors/enumeration.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {ContactDetails} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import ErrorModal from "@/components/modals/error.vue"

  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  onBeforeMount(() => {
    read()
  })

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const contactDetailsTypes = ref<string[]>(null)
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<ContactDetails>
  })

  async function read() {
    try {
      const response = await enumerationClient.readContactDetailsEnumerations()
      contactDetailsTypes.value = response.types
    } catch(e) {
      error.value = e
    }
  }
</script>

<style scoped>
  .column {
    display: inline-block;
    margin: 0 1em 1em 0;
    vertical-align: top;

    &:last-child {
      margin-right: 0;
    }
  }
</style>
